import { Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './TppEmptyCardRegister.css';

type Props = {
  onRegister: () => void;
  onGotoSetup: () => void;
};

/** カード0件時の次アクション（主CTAは「カードを登録する」で見出しと揃える） */
export default function TppEmptyCardRegister({ onRegister, onGotoSetup }: Props) {
  const { t } = useTranslation();
  return (
    <Card className="mb-4 border-0 shadow-sm tpp-empty-register">
      <Card.Body className="text-center py-5 px-3">
        <div className="tpp-empty-register__inner">
          <div className="tpp-empty-register__icon text-primary" aria-hidden>
            <i className="fas fa-id-card" />
          </div>
          <h2 className="h5 mb-2">{t('tpp.empty_next_step_title')}</h2>
          <p className="text-muted mb-4">{t('tpp.empty_next_step_body')}</p>
          <Button variant="primary" size="lg" className="px-4" onClick={onRegister}>
            {t('tpp.empty_register_cta')}
          </Button>
          <div className="mt-3">
            <Button
              variant="link"
              size="sm"
              className="text-decoration-none"
              onClick={onGotoSetup}
            >
              {t('tpp.empty_goto_setup')}
            </Button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
